// ════════════════════════════════════════════════════════════════
// src/utils/idMask.js
// Finding 13 (Aadhar / ID locking) — keeps plain ID numbers OUT of the
// logged-in browser session.
//
// Old records may still hold a plain number (field "aadhar") until they
// are replaced. When the app builds a person's session, it uses these
// helpers so that only the last 4 characters (and the locked reference)
// are ever loaded — never the whole number.
//
// This file imports nothing on purpose (so any file can use it safely).
// ════════════════════════════════════════════════════════════════

/** Last 4 letters/digits of an old plain ID, or "" if too short. */
export function last4Of(text) {
  const clean = String(text ?? "").replace(/[^A-Za-z0-9]/g, "");
  return clean.length >= 4 ? clean.slice(-4).toUpperCase() : "";
}

/** { aadharRef, aadharLast4 } for the session — never the full number. */
export function sessionAadharFields(m) {
  return {
    aadharRef: m?.aadharRef || null,
    aadharLast4: m?.aadharLast4 || last4Of(m?.aadhar) || null,
  };
}

/**
 * A copy of a person (e.g. a family member) with any old plain number
 * removed; its last 4 are kept so the screen can still show them masked.
 */
export function withoutPlainAadhar(person) {
  if (!person || typeof person !== "object") return person;
  const { aadhar, aadharNumber, ...rest } = person;
  const last4 = person.aadharLast4 || last4Of(aadhar) || last4Of(aadharNumber);
  return last4 ? { ...rest, aadharLast4: last4 } : rest;
}
